import { PrimaryButton } from 'component-library/components/buttons/PrimaryButton';
import { Flex } from 'component-library/components/layout/Flex';
import { LinkWrapper } from 'component-library/components/links/LinkWrapper';
import { Body } from 'component-library/components/typography/Body';
import { Heading } from 'component-library/components/typography/Heading';
import { device } from 'component-library/styles/device';
import { StaticImage } from 'gatsby-plugin-image';
import React, { FC } from 'react';
import styled from 'styled-components';
import { getColorScheme } from 'templates/blog-ads/shared';

const CallToActionWrapper = styled(Flex)<{ backgroundColor: string }>`
  flex-direction: column;
  gap: 32px;
  border-radius: 16px;
  padding: 40px;
  background-color: ${({ backgroundColor }) => backgroundColor};

  ${`@media ${device.xl}`} {
    flex-direction: row;
  }
`;

const Image = styled.div`
  flex-basis: 40%;
`;
const Text = styled.div`
  flex-basis: 60%;
`;

interface PreviewCallToActionProps {
  copyHeading: string;
  copySubheading: string;
  buttonCopy: string;
  buttonLink: string;
  imageSelection?: 1 | 2;
  backgroundColor?: string;
}

export const PreviewCallToAction: FC<PreviewCallToActionProps> = ({
  copyHeading,
  copySubheading,
  buttonCopy,
  buttonLink,
  imageSelection = 1,
  backgroundColor = 'teal',
}) => {
  const colorScheme = getColorScheme(backgroundColor);

  return (
    <CallToActionWrapper
      marginTop={32}
      alignItems="center"
      backgroundColor={colorScheme.backgroundColor}
    >
      <Text>
        <Heading variant={4} marginBottom={12} color={colorScheme.fontColor}>
          {copyHeading}
        </Heading>
        <Body
          variant={2}
          marginBottom={32}
          as="div"
          color={colorScheme.fontColor}
        >
          {copySubheading}
        </Body>
        <LinkWrapper to={buttonLink}>
          <PrimaryButton buttonColor={colorScheme.buttonColor}>
            {buttonCopy}
          </PrimaryButton>
        </LinkWrapper>
      </Text>

      <Image>
        {imageSelection === 1 ? (
          <StaticImage
            src="./images/call-to-action.png"
            alt="Income and expenses charts"
          />
        ) : (
          <StaticImage
            src="./images/recession-proof-retirement.png"
            alt="Recession Proof Your Retirement eBook"
          />
        )}
      </Image>
    </CallToActionWrapper>
  );
};
